import { create } from "zustand";

const useSidebar = create((set) => ({
  isOpen: true,

  setIsOpen: (isOpen) =>
    set((state) => ({
      ...state,
      isOpen: isOpen,
    })),
}));

export default useSidebar;
